import { render, staticRenderFns } from "./seek.vue?vue&type=template&id=bf968f30&scoped=true&"
import script from "./seek.vue?vue&type=script&lang=js&"
export * from "./seek.vue?vue&type=script&lang=js&"
import style0 from "./seek.vue?vue&type=style&index=0&id=bf968f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf968f30",
  null
  
)

export default component.exports